import axios from 'axios';
import { userConfigsAction } from './UserConfigsSlice';

const getUserConfigs = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/config`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(userConfigsAction.userConfigsSuccess(result.data));
      return result.data;
    } catch (e) {
      dispatch(userConfigsAction.userConfigsFailure(e.response?.data ?? e.message));
      return null
    }
  };
};

export default getUserConfigs;